import { InjectionToken } from "@angular/core";
import { RechargeRequestsPort } from "./recharge-requests.port";

export const RECHARGE_REQUESTS_PORT = new InjectionToken<RechargeRequestsPort>("RECHARGE_REQUESTS_PORT");
